import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { WsreService } from "../../wsre.service";
import { LoadingService } from "../../../../shared/services/loading.service";
import { ActivatedRoute, Router } from "@angular/router";
import { NotificationsService } from "angular2-notifications";
import {
  ComponentSummary,
  CrackTestSummary,
  DipTestSummary,
  ArrivalPhotoOverview,
  InitialImageType,
  ComponentTabRecord,
  CrackTestTab,
  DipTest,
  DipTestConditionType,
  CreateDipTestsVM,
  WSREActionHistoryVM,
} from "../../models/wsre.model";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { MatDialog } from "@angular/material/dialog";
import { PhotoPopupComponent } from "../../components/photo-popup/photo-popup.component";
import { WsreSendReportComponent } from "../../components/wsre-send-report/wsre-send-report.component";
import { CustomCommentPopupComponent } from "../../components/custom-comment-popup-component/custom-comment-popup.component";
import { AppUris, Tuple } from "../../../../../app/entities";
import { CustomEvalService } from "../../../../../app/modules/CustomEval/custom-eval.service";
import { UserService } from "../../../../../app/shared/services/user.service";
import {
  WSreStatusModel,
  UpdateJobDetailsRequest,
} from "../../../../../app/modules/CustomEval/custom-eval.model";
import {
  AvailableActionsForComponentInInventoryWSRE,
  AvailableActionViewModelNew,
} from "../../wrse.model";
import {
  ComponentOnSystemViewModel,
  GeneralActionViewModel,
  ReplacementCompartmentViewModel,
} from "../../../action/action-models";
import { ActionService } from "../../../action/action.service.service";
import { SystemComponentViewModel } from "../../../inventory/inventory-models";
import { InventoryService } from "../../../inventory/inventory-service.service";
import { RecordActionHistoryPopup } from "../record-action-history-popup/record-action-history-popup.component";
import { TranslateService } from "../../../../../app/translate";
import { ChangeDetectorRef } from "@angular/core";
import {
  ScreenCode,
  toolType,
  toolTypePassFail,
  toolTypeYesNo,
} from "../../../../shared/enums/allEnums";
import {
  trigger,
  transition,
  style,
  animate,
  keyframes,
} from "@angular/animations";
import { PageEvent } from "@angular/material/paginator";
import { CommonFiltersService } from "../../../../shared/services/common-search-filters.service";
import { ChangeComponentComponent } from "../../../../modules/manage-equipment/components/change-component/change-component.component";
import { CustomerServiceIdentity } from "../../../../modules/IDENTITY_WEB/services/customer.service";

@Component({
  selector: "repair-estimate",
  templateUrl: "./repair-estimate.component.html",
  styleUrls: ["./repair-estimate.component.scss"],
  animations: [
    trigger("fadeInOut", [
      transition(":enter", [
        style({ opacity: 0 }),
        animate("500ms", style({ opacity: 1 })),
      ]),
      transition(":leave", [
        style({ opacity: 0 }),
        animate("0ms", style({ opacity: 0 })),
      ]),
    ]),
    trigger("slideOut", [
      transition(":enter", [
        style({ "max-height": "0" }),
        animate(
          "5s",
          keyframes([
            style({ "max-height": "200px", offset: 0 }),
            style({ "max-height": "400px", offset: 0.3 }),
            style({ "max-height": "600px", offset: 0.6 }),
            style({ "max-height": "1400px", offset: 0.9 }),
          ]),
        ),
      ]),
    ]),
  ],
})
export class RepairEstimateComponent implements OnInit {
  WSREStatus: WSreStatusModel[];
  appUris: AppUris;
  wsreId;
  userCanEdit: boolean = false;
  userUom: string = "mm";

  // Overview at top of page
  customerName: string;
  customerReference: string;
  inspectionDate: Date;
  jobNumber: string;
  jobsiteName: string;
  lifeLived: number;
  make: string;
  model: string;
  oldJobNumber: string;
  reportPrepared: boolean = false;
  serialNumber: string;

  // Summary tab
  loadingSummary: boolean = true;
  overallEval: string;
  overallSummaryComment: string;
  overallSummaryRecommendation: string;
  componentSummaries: ComponentSummary[];
  crackTestSummary: CrackTestSummary;
  dipTestSummaries: DipTestSummary[];
  savingOverallEval: boolean = false;

  // Arrival Photos Tab
  arrivalPhotosLoaded: boolean = false;
  arrivalPhotos: ArrivalPhotoOverview[] = [];

  finalPhotosLoaded: boolean = false;
  finalPhotos: ArrivalPhotoOverview[] = [];

  customerReferencePhotos: ArrivalPhotoOverview[] = [];
  oldTagPhotos: ArrivalPhotoOverview[] = [];

  // Components Tab
  componentsLoaded: boolean = false;
  components: ComponentTabRecord[] = [];

  // Crack Test Tab
  crackTestLoaded: boolean = false;
  crackTest: CrackTestTab = new CrackTestTab();
  savingCrackTestEval: boolean = false;

  // Dip Tests Tab
  dipTestsLoaded: boolean = false;
  dipTests: DipTest[] = [];
  possibleDipTestConditions: DipTestConditionType[] = [];

  selectedActionTypeID: number;
  isReplaceWithNewAction;
  isloadingReplacementCompart: boolean;
  availableCompartments: ReplacementCompartmentViewModel[] = [];
  allRollers: ComponentOnSystemViewModel[];
  userLanguage = "english";
  viewPhotos: boolean = false;
  viewComponents: boolean = false;
  viewCrackTests: boolean = false;
  viewDipTests: boolean = false;
  isSerialNumberEditable: boolean = false;

  masterLinkList = [
    {
      id: 0,
      name: "N/A",
    },
    {
      id: 1,
      name: "1",
    },
    {
      id: 2,
      name: "5",
    },
  ];
  SelectedMasterLink: number = 0;
  OtherLinkNum: number;
  NumRequiringReplacement: number;
  ScallopMeasurment: number;
  RunningSide: number;
  ReverseSide: number;
  BushTurned: any;
  ShoeHight: number;
  ShoeWidth: number;
  ShoeReluggedcca: any;
  MasterShoe: any;
  AllHardware: any;
  SystemTypeId: number;
  toolType = toolType;
  toolYesNo = toolTypeYesNo;
  toolPassFail = toolTypePassFail;
  bushTurnTooltip =
    "To change the status of the bush turn, please enter an action via record action";
  shoeReluggedTooltip =
    "To change the status of the shoe relug, please enter an action via record action";
  auditTrailHistory: WSREActionHistoryVM[] = [];
  screenId: number;
  systemIdLeft: string;
  loadSize: number = 25;
  loadingPage: number = 1;
  auditTrailTotalRecords: number = 0;
  auditRefreshCounter = 0;
  isJobSiteEditable: boolean = false;
  selectedJobSiteId: number = 0;
  jobSiteList: any[] = [];
  customerId: number;
  isBasicUser: number = 1;
  allowFieldEditing: boolean = false;
  allowJobsiteEditing: boolean = false;
  isAdministrator: boolean = false;
  viewTab(event) {
    console.log(event.index, event);
    this.viewPhotos = false;
    this.viewComponents = false;
    this.viewCrackTests = false;
    this.viewDipTests = false;
    this.loadingSummary = true;
    switch (event.tab.textLabel) {
      case "Summary":
        this.loadingSummary = false;
        break;
      case "Arrival Photos":
        this.viewPhotos = true;
        break;
      case "Components":
        this.viewComponents = true;
        break;
      case "Crack Tests":
        this.viewCrackTests = true;
        break;
      case "Dip Tests":
        this.viewDipTests = true;
        break;
      case "Audit Trail":
        this.auditRefreshCounter++;
        break;
    }
  }

  constructor(
    private _dialog: MatDialog,
    private _titleService: Title,
    private _wsreService: WsreService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _service: NotificationsService,
    private loadingService: LoadingService,
    private inventoryService: InventoryService,
    private notification: NotificationsService,
    private _actionService: ActionService,
    private _evalService: CustomEvalService,
    private _sanitizer: DomSanitizer,
    private _loading: LoadingService,
    public dialog: MatDialog,
    private _translate: TranslateService,
    private _userService: UserService,
    private cdr: ChangeDetectorRef,
    private _commonService: CommonFiltersService,
    private _customerService: CustomerServiceIdentity
  ) {}
  actionHelper: AvailableActionsForComponentInInventoryWSRE =
    new AvailableActionsForComponentInInventoryWSRE();
  ngOnInit() {
    this._titleService.setTitle("Undercarriage Rebuild Centre");
    this.wsreId = this._route.snapshot.params.id;
    this.SystemTypeId = this._route.snapshot.params.id2;
    this.screenId =
      this.SystemTypeId == 1
        ? ScreenCode.WC
        : this.SystemTypeId == 2
          ? ScreenCode.WI
          : null;
    this.getUserUom();
    this.checkUserCanEdit();
    this.checkUserRoleForEditPermissions();
    this._customerService.CheckUCUserType().subscribe(result => {
      this.isBasicUser = result;
    });
    this.loadOverview();
    this.loadSummary();
    this.loadArrivalPhotos();
    this.loadComponentTab();
    if (this.SystemTypeId == 1) {
      this.loadCrackTestTab();
      this.loadDipTestTab();
      this.loadPossibleDipTestConditionTypes();
    }
    this.LoadWsreStatus();
    this.GetWSRECurrentStatus();
  }

  uploadArrivalPhotos(result) {
    if (result) this.loadArrivalPhotos();
  }

  uploadFinalPhotos(result) {
    if (result) this.loadArrivalPhotos();
  }

  customerReferencePhotoUploaded(result) {
    if (result) this.loadArrivalPhotos();
  }

  oldTagPhotoUploaded(result) {
    if (result) this.loadArrivalPhotos();
  }

  uploadCrackTestPhotos(result) {
    if (result) this.loadCrackTestTab();
  }

  componentPhotoUploaded(result) {
    //console.log("result",result)
    if (result) this.loadComponentTab();
  }

  getUserUom() {
    this._wsreService.getUserUOM().subscribe((uom) => {
      this.userUom = uom;
    });
  }

  checkUserCanEdit() {
    this._wsreService.checkUserCanEdit(this.wsreId).subscribe((canEdit) => {
      this.userCanEdit = canEdit;
    });
  }

  loadPossibleDipTestConditionTypes() {
    this._loading.startLoading();
    this._wsreService.getPossibleDipTestConditionTypes().subscribe((types) => {
      this.possibleDipTestConditions = types;
      this._loading.finishedLoading();
    });
  }

  openImage(photoId: number, photoType: string, childId: number | null) {
    let dialogRef = this.dialog.open(PhotoPopupComponent, {
      panelClass: "removeModalOverflow",
      data: {
        photoId: photoId,
        photoType: photoType,
        userCanDeletePhoto: this.userCanEdit,
        childId: childId,
        ScreenId: this.screenId,
      },
    });

    dialogRef.afterClosed().subscribe((wasDeleted) => {
      if (wasDeleted) {
        switch (photoType) {
          case "initial":
            this.loadArrivalPhotos();
            break;
          case "component":
            this.loadComponentTab();
            break;
          case "cracktest":
            this.loadCrackTestTab();
            break;
          case "diptest":
            this.loadDipTestTab();
            break;
          default:
            this.loadComponentTab();
        }
      }
    });
  }

  updateCrackTestEval(testPassed: boolean) {
    this._loading.startLoading();
    this.savingCrackTestEval = true;
    this._wsreService
      .updateCrackTestEval(this.wsreId, testPassed)
      .subscribe((res) => {
        if (res.m_Item1) {
          this._service.success("Saved", res.m_Item2);
          this.loadCrackTestTab();
          this.loadSummary();
        } else {
          this._service.error("Error", res.m_Item2);
        }
        this._loading.finishedLoading();
        this.savingCrackTestEval = false;
      });
  }

  loadOverview() {
    this._wsreService
      .getRepairEstimateOverview(this.wsreId)
      .subscribe((wsre) => {
        if (wsre == null) {
          this._service.error(
            "Error",
            "Cannot find an estimate with this ID. ",
          );
          return;
        }
        this.customerName = wsre.CustomerName;
        this.customerReference = wsre.CustomerReference;
        this.inspectionDate = wsre.InspectionDate;
        this.jobNumber = wsre.JobNumber;
        this.jobsiteName = wsre.JobsiteName;
        this.lifeLived = wsre.LifeLived;
        this.make = wsre.Make;
        this.model = wsre.Model;
        this.oldJobNumber = wsre.OldJobNumber;
        this.reportPrepared = wsre.ReportPrepared;
        this.serialNumber = wsre.SerialNumber;
        this.systemIdLeft = wsre.TrackFrame_Left_SystemId?.toString() ?? "";
        this.customerId = wsre.CustomerId;
      });
  }

  loadSummary() {
    this._loading.startLoading();
    this._wsreService
      .getRepairEstimateSummary(this.wsreId)
      .subscribe((wsre) => {
        if (wsre == null) {
          this._loading.finishedLoading();
          return;
        }
        this.overallEval = wsre.OverallEval;
        this.overallSummaryComment = wsre.OverallComment;
        this.overallSummaryRecommendation = wsre.OverallRecommendation;
        this.componentSummaries = wsre.Components;
        this.crackTestSummary = wsre.CrackTest;
        this.dipTestSummaries = wsre.DipTests;
        this.loadingSummary = false;
        this._loading.finishedLoading();
      });
  }

  CreateDipTests(num, hasDipTests) {
    if (hasDipTests == false && num != "" && num != null && num > 0) {
      var _val = new CreateDipTestsVM();
      _val.dipTestNum = num;
      _val.WSREId = this.wsreId;
      this._wsreService.CreateDipTests(_val).subscribe((wsre) => {
        this.loadDipTestTab();
        this.loadComponentTab();
      });
    }
  }

  loadArrivalPhotos() {
    this._loading.startLoading();
    this._wsreService
      .getArrivalPhotosOverview(this.wsreId)
      .subscribe((photos) => {
        if (photos == null) {
          this._loading.finishedLoading();
          return;
        }

        //console.log("getArrivalPhotosOverview",photos)
        this.arrivalPhotos = photos.filter((p) =>
          p.Type == InitialImageType.Arrival ? true : false,
        );
        this.oldTagPhotos = photos.filter((p) =>
          p.Type == InitialImageType.OldTag ? true : false,
        );
        this.finalPhotos = photos.filter((p) =>
          p.Type == InitialImageType.Final ? true : false,
        );
        this.customerReferencePhotos = photos.filter((p) =>
          p.Type == InitialImageType.CustomerReference ? true : false,
        );
        this._loading.finishedLoading();
      });
  }

  loadComponentTab() {
    this._loading.startLoading();
    this._wsreService
      .getComponentTabData(this.wsreId)
      .subscribe((components) => {
        this.components = components;
        console.log("components", this.components);
        let comp = this.components.find((f) => f.CompartTypeAuto == 230);
        if (comp) {
          this.SelectedMasterLink = comp.MasterLinkToothCount;
        }

        if (this.components != null) this.componentsLoaded = true;
        this._loading.finishedLoading();
      });
  }

  openConditionComment(comment: string, recordId) {
    const viewCommentModalRef = this._dialog.open(CustomCommentPopupComponent, {
      width: "1032px",
      data: {
        comment: comment,
        componentId: recordId,
      },
    });
    viewCommentModalRef.afterClosed().subscribe((reloadComment) => {
      //console.log("reloadComment",reloadComment)

      if (reloadComment) {
        this.saveComponentComment(
          reloadComment.comment,
          reloadComment.componentId,
        );
      }
    });
  }

  loadCrackTestTab() {
    this._loading.startLoading();
    this._wsreService.getCrackTestTab(this.wsreId).subscribe((crackTest) => {
      this.crackTest = crackTest;

      if (crackTest != null) this.crackTestLoaded = true;
      this._loading.finishedLoading();
    });
  }

  loadDipTestTab() {
    this._loading.startLoading();
    this._wsreService.getDipTests(this.wsreId).subscribe((dipTests) => {
      this.dipTests = dipTests;
      //console.log(this.dipTests);
      if (this.dipTests != null) this.dipTestsLoaded = true;
      this._loading.finishedLoading();
    });
  }

  getImage(image: string) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(
      "data:image/png;base64," + image,
    );
  }

  saveComponentComment(newComment, recordId) {
    this._loading.startLoading();
    this._wsreService
      .updateComponentRecordComment(recordId, newComment, this.screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadSummary();
          this.loadComponentTab();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  public updateComponentTool(
    measurement: number,
    recordId: number,
    toolId: number,
    component: any,
  ) {
    this.saveComponentMeasurement(measurement, recordId, toolId, component);
  }

  isNumeric(num) {
    return !isNaN(num);
  }

  saveChildComponentMeasurement(
    value,
    recordId,
    toolId,
    childID,
    isToggle,
    group,
  ) {
    /**
        1-Other Links
        2-Number Requiring Replacement
        3-Scallop Measurment mm
        4-Running Side mm
        5-Reverse Side mm
        6-Shoe Hight mm
        7-Shoe Width mm
        8-Bush Turned
        9-Shoe Reluggedcca
        10-Master shoe
        11-All Hardware present
        12-Hardware Condition
        13-Master Link
        14-Master Crack Test
15-OLinkCrackTest
16-BushCrackTest
17-ShoeCrackTest
18-BrokenBoltRHPE
19-BrokenBoltLHPE
20-MasterLinkRHPE
21-MasterLinkLHPE
22-MasterLinkRHBE
23-MasterLinkLHBE

24-Idlr_Dia_A_New
25-Idlr_Dia_A_100prc
26-Idlr_Dia_B_New
27-Idlr_Dia_B_100prc
28-Idlr_WidthOfCG_New
29-Idlr_ShaftOTR-bool 
30-Idlr_Measure_in_to_150_1 
31-Idlr_Measure_in_to_150_2
32-Idlr_No_1_side_NS_Face
33-Idlr_No_1_side_NS_Middle
34-Idlr_No_1_side_NS_Centre
35-Idlr_No_1_side_ES_Face
36-Idlr_No_1_side_ES_Middle
37-Idlr_No_1_side_ES_Centre
38-Idlr_No_2_side_NS_Face
39-Idlr_No_2_side_NS_Middle
40-Idlr_No_2_side_NS_Centre
41-Idlr_No_2_side_ES_Face
42-Idlr_No_2_side_ES_Middle
43-Idlr_No_2_side_ES_Centre

44-Idlr_No_1_side_retainer -bool
45-Idlr_No_1_side_collar -bool
46-Idlr_No_1_side_thrust -bool
47-Idlr_No_2_side_retainer -bool
48-Idlr_No_2_side_collar -bool
49-Idlr_No_2_side_thrust -bool
50-Idlr_No_2_side_bolts -bool
51-Idlr_No_2_side_washers -bool

52-Idlr_Dia_A_measurment -decimal -2
53-Idlr_Dia_B_measurment -decimal -2
54-WidthOfCenterGuide_measurment -decimal -2

55-Idlr_WidthOfCG_New_photo
56-Idlr_ShaftOTR_photo
57-Idlr_No_1_side_NS_photo
58-Idlr_No_1_side_ES_photo
59-Idlr_No_2_side_NS_photo
60-Idlr_No_2_side_ES_photo
61-Idlr_No_1_side_retainer_photo
62-Idlr_No_2_side_retainer_photo
63-Idlr_bolts_washer_photo

        */
    // if (isNaN(newMeasurement)) {
    //     this._service.error('Error', 'Please enter a valid measurement. Eg: 10.004');
    //     return;
    // }

    let newMeasurement = "";
    if (isToggle) {
      if (newMeasurement === value) {
        group.value = "";
        newMeasurement = "";
      } else {
        newMeasurement = value > 0 ? value : "";
      }
    } else {
      newMeasurement = value;
    }

    if (childID == 52 || childID == 53 || childID == 54) {
      if (this.isNumeric(value)) {
        let cpy = (Math.round(value * 100) / 100).toFixed(2);
        newMeasurement = "" + cpy;
      } else {
        return;
      }
    }

    //console.log("childID,newMeasurement,isToggle",childID,newMeasurement,isToggle)

    this._loading.startLoading();
    this._wsreService
      .updateChildComponentRecordMeasurement(
        recordId,
        newMeasurement,
        childID,
        this.screenId,
      )
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadComponentTab();
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveComponentMeasurement(newMeasurement, recordId, toolId, component: any) {
    if (isNaN(newMeasurement)) {
      this._service.error(
        "Error",
        "Please enter a valid measurement. Eg: 10.004",
      );
      return;
    }
    this._loading.startLoading();
    this._wsreService
      .updateComponentRecordMeasurement(
        recordId,
        newMeasurement,
        toolId,
        this.screenId,
      )
      .subscribe((result) => {
        if (result.m_Item1) {
          let comp = new SystemComponentViewModel();
          comp.ComponentId = component.ComponentId;
          comp.Brand = component.Brand;
          comp.CompartId = component.CompartId;
          comp.Budget = 0;
          comp.CMU = component.Cmu;
          comp.CompartType = component.CompartTypeAuto;
          comp.ComponentId = component.ComponentId;
          comp.EqunitId = component.ComponentId;
          comp.MakeId = component.MakeId;
          comp.MeasurementPoints = newMeasurement;
          comp.ToolId = component.ToolId;
          comp.Name = component.Component;
          //TT-9974
          comp.DOC = component.DOC;
          this.measurementChanged(newMeasurement, comp);
          this._service.success("Saved", result.m_Item2);
          this.loadComponentTab();
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  changeEval(
    value: string,
    componentDetailId: number,
    component: SystemComponentViewModel,
  ) {}

  saveCrackTestComment(newComment) {
    this._loading.startLoading();
    this._wsreService
      .updateCrackTestComment(this.wsreId, newComment)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadCrackTestTab();
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveDipTestLevel(id: number, newLevel: number) {
    //console.log("id: number, newLevel: number", id, newLevel)
    if (isNaN(newLevel)) {
      this._service.error("Error", "Please enter a valid level. Eg: 12");
      return;
    }
    this._loading.startLoading();
    this._wsreService
      .updateDipTestLevel(id, newLevel, this.screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadDipTestTab();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveDipTestComment(id: number, newComment: string) {
    this._loading.startLoading();
    this._wsreService
      .updateDipTestComment(id, newComment, this.screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveDipTestRecommendation(id: number, newRecommendation: string) {
    this._loading.startLoading();
    this._wsreService
      .updateDipTestRecommendation(id, newRecommendation, this.screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveDipTestCondition(id: number, conditionId: number) {
    this._loading.startLoading();
    this._wsreService
      .updateDipTestCondition(id, conditionId, this.screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadDipTestTab();
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveOverallSummaryComment(comment: string) {
    this._loading.startLoading();
    this._wsreService
      .updateOverallSummaryComment(this.wsreId, comment, this.screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveOverallSummaryRecommendation(recommendation: string) {
    this._loading.startLoading();
    this._wsreService
      .updateOverallSummaryRecommendation(
        this.wsreId,
        recommendation,
        this.screenId,
      )
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
      });
  }

  saveOverallEval(overallEval: string) {
    this.savingOverallEval = true;
    this._loading.startLoading();
    this._wsreService
      .updateOverallEval(this.wsreId, overallEval, this.screenId)
      .subscribe((result) => {
        if (result.m_Item1) {
          this._service.success("Saved", result.m_Item2);
          this.loadSummary();
        } else {
          this._service.error("Error", result.m_Item2);
        }
        this._loading.finishedLoading();
        this.savingOverallEval = false;
      });
  }

  isInt(n) {
    return typeof n == "number" && n % 1 == 0;
  }

  dipTestPhotoUploaded(result) {
    if (result) this.loadDipTestTab();
  }

  sendReport() {
    let sendReportModalRef = this.dialog.open(WsreSendReportComponent, {
      width: "640px",
      height: "500px",
      data: {
        WSREInspectionID: this.wsreId,
        type: this.SystemTypeId,
      },
    });
    sendReportModalRef.afterClosed().subscribe((res) => {
      if (res != null) {
        // var sendToAddress: string = res.data;
        // this._rbService.SendReport(this.MSInspectionID, sendToAddress).subscribe(r2 => {
        //     if (r2 != null && r2 == true) {
        //         alert("Successfully sent report.");
        //     } else {
        //         alert("Failed to send report!");
        //     }
        // });
      }
    });
  }

  GetPdfIdler(wsreId: number) {
    //console.log("report works")
    window.open(
      this.appUris.UCUri + "api/WSRE/GetPdfIdler?wsreId=" + wsreId,
      "_blank",
    );
  }

  WSREStatusID: number;
  LoadWsreStatus() {
    this._evalService.LoadWsreStatus().subscribe((res) => {
      this.WSREStatus = res;
    });
  }

  GetWSRECurrentStatus() {
    this._evalService.GetWSRECurrentStatus(this.wsreId).subscribe((res) => {
      this.WSREStatusID = res.LeftSideStatus;
    });
  }
  public currentClickedId: number = 0;

  availableActions: AvailableActionViewModelNew[] = [];
  allComponents: ComponentOnSystemViewModel[];
  loadActions(componenttypeID: number, componentid: number, SystemId: number) {
    this.isPopupVisible = false;
    this.currentClickedId = componentid;
    this.isPopupVisible = !this.isPopupVisible;
    this.availableActions = this.actionHelper.GetActions(componenttypeID);

    this._actionService.getComponentsOnThisSystem(SystemId).subscribe((r) => {
      console.log(r);
      this.allComponents = r;
    });
    console.log(this.availableActions);
  }

  popupClose() {
    if (this.isPopupVisible) this.isPopupVisible = false;
  }
  isPopupVisible: boolean = false;
  action = new GeneralActionViewModel();
  RecordAction() {
    this.action.ActionEqUnitId = this.currentClickedId;
    this.action.SystemType = 1;
    this.action.ActionTypeId = this.selectedActionTypeID;
    this.action.WsreId = this.wsreId;
    this._actionService.recordNewInventoryAction(this.action).subscribe((a) => {
      console.log(a);
      if (a.m_Item1) {
        this.notification.success("Successfully Recorded WSRE Action");
        this.loadComponentTab();
      } else {
        this.notification.error(
          "Failed to Recorded Inventory Action  " + a.m_Item2,
        );
        console.log(a.m_Item2);
      }
      this.selectedActionTypeID = 0;
    });
  }
  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  onCheckboxChange(
    option: AvailableActionViewModelNew,
    CompartTypeID: number,
    componentID: number,
  ) {
    this.selectedActionTypeID = option.ActionTypeId;
    this.action.ActionTypeName = option.ActionTypeName;
    const checkString = option.ActionTypeName.split(" ");
    if (checkString[0] === "Replace") {
      //this.loadingService.startLoading();
      //this.isloadingReplacementCompart = true;
      this.isReplaceWithNewAction = true;
      this._actionService
        .getReplacementComponentOptions(componentID)
        .subscribe((r) => {
          //this.loadingService.finishedLoading();
          this.isloadingReplacementCompart = false;
          console.log(r);
          this.availableCompartments = r;
        });
    } else {
      this.isReplaceWithNewAction = false;
    }

    if (
      +this.selectedActionTypeID === 10602 ||
      +this.selectedActionTypeID === 17 ||
      +this.selectedActionTypeID === 10702
    ) {
      this.allRollers = this.allComponents.filter(
        (c) => c.CompartTypeId === CompartTypeID,
      );
    }
    // Toggle logic: if the clicked checkbox is already selected, deselect it.
    // this.selectedOption = this.selectedOption === option.ActionTypeId ? null : option;
  }
  measurementChanged(event, component: SystemComponentViewModel) {
    //debugger;
    component.LastestInpsectionId = 0;
    // this.loadingService.startLoading();
    this.inventoryService
      .getWornPercentageCalculationMethod(
        component.CompartId,
        component.ToolId,
        event,
        component.LastestInpsectionId,
        component.ComponentId,
      )
      .subscribe((r) => {
        component.WornPercentage = r.m_Item1;
        component.Condition = r.m_Item2;
        this.inventoryService
          .updateSystemInInventoryInfo(component)
          .subscribe((res) => {
            this.popupNotification(res);
          });
        this.loadingService.finishedLoading();
      });
  }
  private popupNotification(result: Tuple) {
    this.loadingService.finishedLoading();
    if (result.m_Item1) {
      this.notification.success(result.m_Item2);
    } else {
      this.notification.error(result.m_Item2);
    }
  }
  OnStatusChange() {
    this.inventoryService
      .UpdateWsreStatus(this.wsreId, this.WSREStatusID, "Left", this.screenId)
      .subscribe((a) => {
        if (a == true) {
          this.notification.success("Updated Successfully");
        } else {
          this.notification.error("Something went wrong");
        }
      });
  }

  openHistory(component: any) {
    const viewCommentModalRef = this._dialog.open(RecordActionHistoryPopup, {
      data: {
        component: component.ComponentId,
      },
    });
    viewCommentModalRef.afterClosed().subscribe((reloadComment) => {});
  }

  //action = new GeneralActionViewModel();

  replacementCompartChanged(event, EqunitId: number) {
    // get budget life
    console.log(event);
    this.loadingService.startLoading();
    // this.action.ReplaceComponentCompartId = this.component.
    this._actionService.getComponentBudgetLife(EqunitId).subscribe((l: any) => {
      this.loadingService.finishedLoading();
      this.action.BudgetLife = l;
    });
  }
  isJobNumberEditable: boolean = false;
  originalJobNumber: string = "";

  toggleSerialNumberEdit(editable: boolean): void {
    this.isSerialNumberEditable = editable;
    this.cdr.detectChanges();
  }

  toggleJobNumberEdit(editable: boolean): void {
    this.isJobNumberEditable = editable;
    this.cdr.detectChanges();
  }

  saveJobNumber() {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      ScreenId: this.screenId
    };

    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Record saved successfully"), response);
        this.isJobNumberEditable = false;
      },
      error: (err) => {
        console.error("Error saving Job Number:", err);
      },
    });
  }
  // Example value
  isCustomerReferenceEditable: boolean = false;

  toggleCustomerReferenceEdit(isEditable: boolean): void {
    this.isCustomerReferenceEditable = isEditable;
  }

  saveSerialNumber() {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      ScreenId: this.screenId
    };

    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Record saved successfully"), response);
        this.toggleSerialNumberEdit(false);
      },
      error: (err) => {
        console.error("Error saving Job Number:", err);
      },
    });
  }

  // saveCustomerReference(): void {
  //   // Add your save logic here
  //   console.log('Customer Reference Saved:', this.customerReference);
  //   this.toggleCustomerReferenceEdit(false);
  // }
  saveCustomerReference(): void {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      ScreenId: this.screenId
    };

    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Record saved successfully"), response);
        this.toggleCustomerReferenceEdit(false);
      },
      error: (err) => {
        console.error("Error saving Customer Reference:", err);
      },
    });
  }

  // Example value
  isOldJobNumberEditable: boolean = false;

  toggleOldJobNumberEdit(isEditable: boolean): void {
    this.isOldJobNumberEditable = isEditable;
  }

  saveOldJobNumber(): void {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      ScreenId: this.screenId
    };

    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Record saved successfully"), response);
        this.toggleOldJobNumberEdit(false);
      },
      error: (err) => {
        console.error("Error saving Old Job Number:", err);
      },
    });
  }

  checkUserRoleForEditPermissions(): void {
    this.allowFieldEditing = false;
    this._userService.getUserJobRoles().subscribe((roles) => {
      roles.forEach((role) => {
        if (role.Name === "Administrator" || role.Name === "Customer Admin") {
          this.allowFieldEditing = true;
          this.isAdministrator = true;
        }
        if (role.AllowEdit) this.allowJobsiteEditing = true;
      });
    });
  }

  loadActionHistory(loadingPage: number, pageSize: number) {
    this._loading.startLoading();
    this._wsreService
      .getActionHistory(
        this.systemIdLeft,
        this.screenId,
        4,
        loadingPage,
        pageSize,
      )
      .subscribe({
        next: (res) => {
          this.auditTrailHistory = res.Data;
          this.auditTrailTotalRecords = res.TotalRecords;
        },
        error: (err) => {
          console.error("Failed to load history", err);
          this._loading.finishedLoading();
        },
        complete: () => {
          this._loading.finishedLoading();
        },
      });
  }

  pageChanged(event: PageEvent) {
    console.log(event);
    this.loadActionHistory(event.pageIndex + 1, event.pageSize);
  }

  toggleJobSiteEdit(value: boolean) {
    if (this.allowJobsiteEditing) {
      this.allowJobsiteEditing = value;
      this.getJobsite();
    }
  }
  getJobsite() {
    this._commonService.getJobsiteList(this.customerId).subscribe((res) => {
      this.jobSiteList = res;
    });
  }

  saveJobSite(site: any) {
    const updateJobDetailsRequest: UpdateJobDetailsRequest = {
      wsreId: this.wsreId,
      jobNumber: this.jobNumber,
      customerReference: this.customerReference,
      oldJobNumber: this.oldJobNumber,
      serialNumber: this.serialNumber,
      JobsiteId: site.Id,
      ScreenId: this.screenId,
    };
    this._evalService.UpdateJobDetails(updateJobDetailsRequest).subscribe({
      next: (response) => {
        (this.notification.success("Jobsite saved successfully"), response);
        this.jobsiteName = site.Name;
      },
      error: (err) => {
        console.error("Error saving Jobsite:", err);
      },
    });
  }

  openEditComponentPopup(component: ComponentTabRecord) {
      //console.log("comparttype_auto: number, compartid_auto: number", CompartId, CompartTypeId);
      const viewModalRef = this._dialog.open(ChangeComponentComponent, {
        width: '500px',
        data: {
          eQunitId: component.ComponentId,
          comparttype_auto: component.CompartTypeAuto,
          compartid_auto: component.CompartId,
          shoeSizeId: component.ShoeSize ?? 0,
          shoeGrouserId: component.GrouserId ?? 0,
          cleanerHolesId: component.CleanerHolesId ?? 0,
          make: component.MakeId,
          budgetLife: component.BudgetLife,
          masterLink: component.MLink,
          jobNumber: component.JobNumber,
          bushTurnedBudgetPer: component.BushTurnedPercent,
          assetNumber: component.AssetNumber,
          bushTurnedHour: component.BushTurnedBudgetLife,
          wornPercentage: component.WornPercentage,
          cmu: component.Cmu,
          screenId: this.screenId
        }
      });
      viewModalRef.afterClosed().subscribe(result => {
        console.log("viewModalRef.afterClosed() result:", result);
        if (result) {
          //this.loadEquipmentSystems();
          this.loadComponentTab();
        }
      });
    }
}

export enum WSREPhotoUpload {
  component = 0,
  dipTest = 1,
}
